import React from 'react';

export default function RatingHistogram({ histogram = {}, count = 0, variant = 'default' }) {
  const rows = [5, 4, 3, 2, 1];
  const total = count || rows.reduce((sum, r) => sum + (histogram[String(r)] || 0), 0) || 1;

  if (variant === 'sidebar') {
    return (
      <div className="space-y-2">
        {rows.map((r) => {
          const value = histogram[String(r)] || 0;
          const pct = Math.max(0, Math.min(100, Math.round((value / total) * 100)));
          return (
            <div key={r} className="flex items-center gap-2 text-sm">
              <div className="w-5 flex items-center justify-end text-gray-900 dark:text-white">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" className="mr-1"><path d="M12 .587l3.668 7.431 8.2 1.193-5.934 5.786 1.401 8.172L12 18.897l-7.335 3.872 1.401-8.172L.132 9.211l8.2-1.193z"/></svg>
                <span className="text-xs font-medium">{r}</span>
              </div>
              <div className="flex-1 h-2 rounded-full bg-gray-100 dark:bg-gray-700">
                <div className="h-2 rounded-full bg-gray-900 dark:bg-white" style={{ width: `${pct}%` }} />
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  const max = Math.max(1, ...rows.map((r) => histogram[String(r)] || 0));
  return (
    <div className="space-y-1">
      {rows.map((r) => {
        const value = histogram[String(r)] || 0;
        const pct = Math.round((value / max) * 100);
        return (
          <div key={r} className="flex items-center gap-2 text-sm">
            <span className="w-4 text-right text-gray-600 dark:text-gray-400">{r}</span>
            <div className="flex-1 h-2 bg-gray-200 dark:bg-gray-700 rounded">
              <div className="h-2 bg-yellow-500 rounded" style={{ width: `${pct}%` }} />
            </div>
            <span className="w-8 text-gray-600 dark:text-gray-400 text-right">{value}</span>
          </div>
        );
      })}
      <div className="text-xs text-gray-500 dark:text-gray-400">{count} reviews</div>
    </div>
  );
}


